"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.number.constructor");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryLog',
  props: {
    deliveryNo: {
      type: String,
      default: ''
    },
    sendDate: {
      type: String,
      default: ''
    },
    doorTime: {
      type: [Array, String],
      default: function _default() {
        return ['', ''];
      }
    },
    deliveryType: {
      type: String,
      default: '配送'
    },
    detailId: {
      type: [String, Number],
      default: null
    },
    sendStatus: {
      type: Number,
      default: null
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    hasLargeFurniture: {
      type: String,
      default: ''
    },
    accountingTotalPackages: {
      type: Number,
      default: 0
    },
    accountingTotalInPackages: {
      type: Number,
      default: 0
    },
    accountingTotalArea: {
      type: Number,
      default: 0
    },
    accountingTotalVol: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      logData: null,
      reserveCountdownText: '00:00:00',
      departCountdownText: '00:00:00',
      accountingSubmitting: false,
      accountingSaving: false,
      _countdownTimer: null
    };
  },
  watch: {
    deliveryNo: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.loadLog();
        }
      }
    },
    sendStatus: {
      immediate: true,
      handler: function handler() {
        this.startCountdown();
      }
    }
  },
  mounted: function mounted() {
    if (this.deliveryNo) {
      this.loadLog();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._countdownTimer) clearInterval(this._countdownTimer);
  },
  methods: {
    loadLog: function loadLog() {
      var _this = this;

      var sendNumber = this.deliveryNo;
      if (!sendNumber) return;
      (0, _send.getSendTaskLog)({
        page: 0,
        size: 1000,
        sendNumber: sendNumber
      }).then(function (res) {
        if (res.code === 200 && res.data && res.data.content) {
          var logs = res.data.content;
          var log = {
            reserveTimeliness: '',
            arrivalTimeliness: ''
          };
          var reserveTime = null;
          var signTime = null;

          var deadline = _this.calcDeadline();

          logs.forEach(function (item) {
            var step = item.step || '';

            if (step === '10') {
              log.reservePerson = item.createByName || item.createBy;
              log.reserveTime = item.createTime;
              reserveTime = item.createTime;
              log.reserveRemark = item.remark || '';

              if (item.photo) {
                log.reservePhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                });
              }
            } else if (step === '-1') {
              if (!log.exceptionList) log.exceptionList = [];
              log.exceptionList.push({
                person: item.createByName || item.createBy,
                remark: item.remark || '',
                time: item.createTime || '',
                photo: item.photo ? item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                }) : []
              });
            } else if (step === '20') {
              log.loadingPerson = item.createByName || item.createBy;
              log.departureTime = item.createTime;

              if (item.photo) {
                log.loadingPhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                });
              }
            } else if (step === '30') {
              log.checkInPerson = item.createByName || item.createBy;
              log.checkInTime = item.createTime;
              signTime = item.createTime;

              if (item.remark) {
                log.checkInAnomaly = true;
                log.checkInAnomalyRemark = item.remark;
              }

              if (item.photo) {
                log.checkInAnomalyPhoto = item.photo.split(',').filter(Boolean).map(function (url) {
                  return {
                    url: url.trim()
                  };
                });
              }
            } else if (step === '40') {
              log.deliverPerson = item.createByName || item.createBy;
              log.deliverTime = item.createTime;
              log.deliverCabinetCount = item.quantity;
              log.deliverPackageCount = item.quantity;

              if (item.photo) {
                try {
                  var photoData = JSON.parse(item.photo);

                  if (photoData.checkImages) {
                    log.siteCheckPhoto = _this.parseAttachmentUrls(photoData.checkImages);
                  }

                  if (photoData.deliveryImages) {
                    log.deliveryCompletePhoto = _this.parseAttachmentUrls(photoData.deliveryImages);
                  }

                  if (photoData.deliveryNoteImages) {
                    log.deliveryOrderPhoto = _this.parseAttachmentUrls(photoData.deliveryNoteImages);
                  }

                  if (photoData.installImages) {
                    log.installPhoto = _this.parseAttachmentUrls(photoData.installImages);
                  }
                } catch (e) {
                  var photos = item.photo.split(',').filter(Boolean).map(function (u) {
                    return {
                      url: u.trim()
                    };
                  });
                  log.siteCheckPhoto = photos;
                  log.deliveryCompletePhoto = photos;
                  log.deliveryOrderPhoto = photos;
                }
              }

              if (item.video) {
                try {
                  var parsed = JSON.parse(item.video);
                  log.siteCheckVideo = Array.isArray(parsed) ? parsed.map(function (url) {
                    return {
                      url: url
                    };
                  }) : [{
                    url: item.video
                  }];
                } catch (_unused) {
                  log.siteCheckVideo = [{
                    url: item.video
                  }];
                }
              }
            } else if (step === '50') {
              log.accountingPerson = item.createByName || item.createBy;
              log.accountingTime = item.createTime;
              log.accountingPackageCount = item.quantity;

              if (item.photo) {
                try {
                  var accountingData = JSON.parse(item.photo);

                  if (accountingData.items) {
                    log.accountingItems = accountingData.items;
                  }
                } catch (e) {
                  log.accountingItems = [];
                }
              }
            } else if (step === '1010' || step === '1011') {
              log.auditPerson = item.createByName || item.createBy;
              log.auditTime = item.createTime;
              log.auditOpinion = item.remark || '';
              log.auditStep = step;
            } else if (step === '1040' && _this.deliveryType === '自提') {
              log.deliveryDeliveryPerson = item.createByName || item.createBy;
              log.deliveryDeliveryTime = item.createTime;

              if (item.photo) {
                try {
                  var _photoData = JSON.parse(item.photo);

                  if (_photoData.deliveryChecklist) {
                    log.deliveryChecklistPhoto = _this.parseAttachmentUrls(_photoData.deliveryChecklist);
                  }

                  if (_photoData.loadingCompletePhoto) {
                    log.deliveryLoadingCompletePhoto = _this.parseAttachmentUrls(_photoData.loadingCompletePhoto);
                  }
                } catch (e) {}
              }
            } else if (step === '1040' && _this.deliveryType === '物流') {
              log.deliveryDeliveryPerson = item.createByName || item.createBy;
              log.deliveryDeliveryTime = item.createTime;

              if (item.photo) {
                try {
                  var _photoData2 = JSON.parse(item.photo);

                  if (_photoData2.logisticsOrderPhoto) {
                    log.logisticsOrderPhoto = _this.parseAttachmentUrls(_photoData2.logisticsOrderPhoto);
                  }

                  if (_photoData2.logisticsCollectionPhoto) {
                    log.logisticsCollectionPhoto = _this.parseAttachmentUrls(_photoData2.logisticsCollectionPhoto);
                  }

                  if (_photoData2.logisticsTrackingNo) {
                    log.logisticsTrackingNo = _photoData2.logisticsTrackingNo;
                  }

                  if (_photoData2.logisticsProgress) {
                    log.logisticsProgress = _photoData2.logisticsProgress;
                  }
                } catch (e) {}
              }
            } else if (step === '1040' && _this.deliveryType === '快递') {
              log.deliveryDeliveryPerson = item.createByName || item.createBy;
              log.deliveryDeliveryTime = item.createTime;

              if (item.photo) {
                try {
                  var _photoData3 = JSON.parse(item.photo);

                  if (_photoData3.expressDeliveryPerson) {
                    log.deliveryDeliveryPerson = _photoData3.expressDeliveryPerson;
                  }

                  if (_photoData3.expressDeliveryTime) {
                    log.deliveryDeliveryTime = _photoData3.expressDeliveryTime;
                  }

                  if (_photoData3.expressCollectTime) {
                    log.expressCollectTime = _photoData3.expressCollectTime;
                  }

                  if (_photoData3.expressOrderPhoto) {
                    log.expressOrderPhoto = _this.parseAttachmentUrls(_photoData3.expressOrderPhoto);
                  }

                  if (_photoData3.expressCollectionPhoto) {
                    log.expressCollectionPhoto = _this.parseAttachmentUrls(_photoData3.expressCollectionPhoto);
                  }

                  if (_photoData3.expressTrackingNo) {
                    log.expressTrackingNo = _photoData3.expressTrackingNo;
                  }

                  if (_photoData3.expressProgress) {
                    log.expressProgress = _photoData3.expressProgress;
                  }
                } catch (e) {}
              }
            } else if (step === '1040' && _this.deliveryType === '闪送') {
              log.deliveryDeliveryPerson = item.createByName || item.createBy;
              log.deliveryDeliveryTime = item.createTime;

              if (item.photo) {
                try {
                  var _photoData4 = JSON.parse(item.photo);

                  if (_photoData4.expressSendDeliveryPerson) {
                    log.deliveryDeliveryPerson = _photoData4.expressSendDeliveryPerson;
                  }

                  if (_photoData4.expressSendDeliveryTime) {
                    log.deliveryDeliveryTime = _photoData4.expressSendDeliveryTime;
                  }

                  if (_photoData4.expressSendCollectTime) {
                    log.expressSendCollectTime = _photoData4.expressSendCollectTime;
                  }

                  if (_photoData4.expressSendCollectionPhoto) {
                    log.expressSendCollectionPhoto = _this.parseAttachmentUrls(_photoData4.expressSendCollectionPhoto);
                  }
                } catch (e) {}
              }
            }
          });

          if (reserveTime && deadline) {
            var diffMinutes = (deadline.getTime() - new Date(reserveTime).getTime()) / (1000 * 60);
            log.reserveTimeliness = diffMinutes >= 30 ? '准时预约' : '超时预约';
          }

          if (signTime && deadline) {
            log.arrivalTimeliness = new Date(signTime).getTime() <= deadline.getTime() ? '准时到达' : '超时到达';
          }

          _this.logData = log;

          _this.$emit('log-loaded', log);

          _this.startCountdown();
        }
      }).catch(function (err) {
        console.error('加载送货日志失败:', err);
      });
    },
    calcDeadline: function calcDeadline() {
      var sendDate = this.sendDate;
      if (!sendDate) return null;
      var endTimeStr = '23:59:59';
      var sendTime = this.doorTime;

      if (sendTime && sendTime.length === 2 && sendTime[1]) {
        endTimeStr = sendTime[1];
      } else if (typeof sendTime === 'string' && sendTime) {
        var parts = sendTime.split('-');
        endTimeStr = parts.length > 1 ? parts[1].trim() : sendTime.trim();
      }

      if (endTimeStr.split(':').length === 2) endTimeStr += ':00';
      return new Date(sendDate + ' ' + endTimeStr);
    },
    parseAttachmentUrls: function parseAttachmentUrls(data) {
      if (!data) return [];

      try {
        var parsed = typeof data === 'string' ? JSON.parse(data) : data;
        var arr = Array.isArray(parsed) ? parsed : [];
        if (arr.length === 0) return [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          if (typeof item === 'string') {
            try {
              var o = JSON.parse(item);
              return {
                url: o.url || imgPreviewPrefix + o.realName,
                realName: o.realName
              };
            } catch (_unused2) {
              return {
                url: item.startsWith('http') ? item : imgPreviewPrefix + item
              };
            }
          }

          return {
            url: item.url || imgPreviewPrefix + item.realName,
            realName: item.realName
          };
        });
      } catch (_unused3) {
        return [];
      }
    },
    startCountdown: function startCountdown() {
      var _this2 = this;

      if (this._countdownTimer) clearInterval(this._countdownTimer);
      this.updateReserveCountdown();
      this.updateDepartCountdown();
      this._countdownTimer = setInterval(function () {
        _this2.updateReserveCountdown();

        _this2.updateDepartCountdown();
      }, 1000);
    },
    updateReserveCountdown: function updateReserveCountdown() {
      if (this.sendStatus !== 10) return;

      if (!this.sendDate) {
        this.reserveCountdownText = '-';
        return;
      }

      try {
        var datePart = this.sendDate;
        var timePart = '00:00:00';
        var doorTime = this.doorTime;

        if (doorTime && doorTime.length === 2 && doorTime[0]) {
          timePart = doorTime[0];
        } else if (typeof doorTime === 'string' && doorTime) {
          timePart = doorTime.includes('-') ? doorTime.split('-')[0].trim() : doorTime.trim();
        }

        if (timePart.split(':').length === 2) timePart += ':00';
        var targetTime = new Date(datePart + ' ' + timePart).getTime();
        var diffSeconds = Math.floor((targetTime - Date.now()) / 1000);

        if (diffSeconds < 0) {
          this.reserveCountdownText = '超时';
          return;
        }

        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        var seconds = diffSeconds % 60;
        var dayStr = days > 0 ? days + '天 ' : '';
        this.reserveCountdownText = dayStr + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      } catch (e) {
        console.error('updateReserveCountdown 异常:', e);
        this.reserveCountdownText = '00:00:00';
      }
    },
    updateDepartCountdown: function updateDepartCountdown() {
      if (this.sendStatus !== 20) return;

      if (!this.sendDate) {
        this.departCountdownText = '-';
        return;
      }

      try {
        var deadline = this.calcDeadline();

        if (!deadline) {
          this.departCountdownText = '-';
          return;
        }

        var diffSeconds = Math.floor((deadline.getTime() - Date.now()) / 1000);

        if (diffSeconds < 0) {
          this.departCountdownText = '已超时';
          return;
        }

        var days = Math.floor(diffSeconds / 86400);
        var hours = Math.floor(diffSeconds % 86400 / 3600);
        var minutes = Math.floor(diffSeconds % 3600 / 60);
        var seconds = diffSeconds % 60;
        var dayStr = days > 0 ? days + '天 ' : '';
        this.departCountdownText = dayStr + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
      } catch (e) {
        console.error('updateDepartCountdown 异常:', e);
        this.departCountdownText = '00:00:00';
      }
    },
    getAccountingSummary: function getAccountingSummary(_ref) {
      var _this3 = this;

      var columns = _ref.columns,
          data = _ref.data;
      var sums = [];
      var totalDeliveryCommission = data.reduce(function (sum, row) {
        return sum + (row.deliveryCommission || 0);
      }, 0);
      var totalBigHomeInstallCommission = data.reduce(function (sum, row) {
        return sum + (row.bigHomeInstallCommission || 0);
      }, 0);
      var totalFloorCount = data.reduce(function (sum, row) {
        return sum + (row.floorCount || 0);
      }, 0);
      var totalFloorCommission = data.reduce(function (sum, row) {
        return sum + (row.floorCommission || 0);
      }, 0);
      var totalOtherCommission = data.reduce(function (sum, row) {
        return sum + (row.otherCommission || 0);
      }, 0);
      columns.forEach(function (col, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        switch (index) {
          case 3:
            sums[index] = _this3.accountingTotalPackages;
            break;

          case 4:
            sums[index] = _this3.accountingTotalInPackages;
            break;

          case 5:
            sums[index] = _this3.accountingTotalArea.toFixed(2);
            break;

          case 6:
            sums[index] = _this3.accountingTotalVol.toFixed(2);
            break;

          case 7:
            sums[index] = totalDeliveryCommission;
            break;

          case 8:
            sums[index] = totalBigHomeInstallCommission;
            break;

          case 9:
            sums[index] = totalFloorCount;
            break;

          case 10:
            sums[index] = totalFloorCommission;
            break;

          case 11:
            sums[index] = totalOtherCommission;
            break;

          default:
            sums[index] = '';
        }
      });
      return sums;
    },
    handleAccountingSubmit: function handleAccountingSubmit() {
      var _this4 = this;

      this.$confirm('确认提交核算信息？提交后状态将变更为"已核算"，不可再修改。', '确认提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.accountingSubmitting = true;

        var items = _this4.contractList.map(function (s) {
          var item = {
            orderSolutionId: s.id
          };
          if (s.deliveryCommission != null) item.deliveryCommission = s.deliveryCommission;
          if (s.bigHomeInstallCommission != null) item.bigHomeInstallCommission = s.bigHomeInstallCommission;
          if (s.floorCount != null) item.floorCount = s.floorCount;
          if (s.floorCommission != null) item.floorCommission = s.floorCommission;
          if (s.otherCommission != null) item.otherCommission = s.otherCommission;
          if (s.accountingRemark != null) item.accountingRemark = s.accountingRemark;
          return item;
        });

        (0, _send.accountingSubmit)(_this4.detailId, {
          items: items
        }).then(function () {
          _this4.$message.success('核算提交成功');

          _this4.loadLog();

          _this4.accountingSubmitting = false;

          _this4.$emit('reload-contract');
        }).catch(function () {
          _this4.$message.error('核算提交失败，请重试');

          _this4.accountingSubmitting = false;
        });
      }).catch(function () {});
    },
    handleAccountingSave: function handleAccountingSave() {
      var _this5 = this;

      this.accountingSaving = true;
      var items = this.contractList.map(function (s) {
        var item = {
          orderSolutionId: s.id
        };
        if (s.deliveryCommission != null) item.deliveryCommission = s.deliveryCommission;
        if (s.bigHomeInstallCommission != null) item.bigHomeInstallCommission = s.bigHomeInstallCommission;
        if (s.floorCount != null) item.floorCount = s.floorCount;
        if (s.floorCommission != null) item.floorCommission = s.floorCommission;
        if (s.otherCommission != null) item.otherCommission = s.otherCommission;
        if (s.accountingRemark != null) item.accountingRemark = s.accountingRemark;
        return item;
      });
      (0, _send.accountingSave)(this.detailId, {
        items: items
      }).then(function () {
        _this5.$message.success('核算暂存成功');

        _this5.accountingSaving = false;
      }).catch(function () {
        _this5.$message.error('核算暂存失败，请重试');

        _this5.accountingSaving = false;
      });
    }
  }
};
exports.default = _default2;